import { CONST } from '@/utils/constants'
import { URLS } from '@/utils/urls'

import Vue from 'vue'
import { rowLimit } from '@/clipboard/limits.js'

export const removeQueryParam = (params, toRemove) => {
  // Force Remove into List
  const toRemoveList = Array.isArray(toRemove) ? toRemove : [ toRemove ]
  // Return new Query Object
  return Object.keys(params).reduce((allowed, key) => {
    const value = params[key]
    // Get Pair as long key isn't in Removal List
    const pair = (toRemoveList.includes(key.toLowerCase()) === false) ? { [key]: value } : { }
    // Merge with existing key/value pairs
    return { ...allowed, ...pair }
  }, { })
}
export const setOrDeleteCookie = (key, value) => (value) ? Vue.cookie.set(key, value, { expires: CONST.Cookies.Settings.LifeSpan }) : Vue.cookie.delete(key)
export const makeContinuationURL = (route) => `${URLS.Public.Login()}?continue=${encodeURIComponent(CONST.Services.Paths.Vue)}${encodeURIComponent(route.path)}`
export const isVueRoute = (route) => (route.matched[0].name !== 'NotFound')
export const isNullOrUndefined = (val) => val === undefined || val === null
export const extractData = (response) => response.data
export const rowCountLimitErrorMessage = () => Vue.i18n.translate('row count limit error message', { 'pageSize': CONST.Grid.PageSize })
export const opensWithNewWorkspace = (type) => ['Grid', 'Chart', 'Metric', 'Trigger'].includes(type)
export const getOpenURLByType = (type, id) => (URLS.App.Open[type]) ? URLS.App.Open[type](id) : null

export const vuex = {
  strict: process.env.NODE_ENV !== 'production'
}

export const bulkEditErrorMessage = (action) => {
  const actionString = Vue.i18n.translate(action)
  return Vue.i18n.translate('bulk edit error message', { 'action': actionString, 'rowLimit': rowLimit })
}
export const readOnlyModeErrorMessage = () => Vue.i18n.translate('closing list view message')

export const ApiVersionHeader = {
  [CONST.ApiSettings.ApiVersionHeader]: CONST.ApiSettings.ApiVersion
}

export default {
  extractData,
  removeQueryParam,
  setOrDeleteCookie,
  makeContinuationURL,
  isVueRoute,
  isNullOrUndefined,
  bulkEditErrorMessage,
  vuex,
  rowCountLimitErrorMessage,
  opensWithNewWorkspace,
  getOpenURLByType,
  ApiVersionHeader
}
